import { NavigateOptions, useNavigate } from "react-router-dom";
import { Routes, RouteSearch } from "../constants/routes";
import { useCallback } from "react";

// import { AppPathname, AppRoute } from "../types/routes";

export const useAppNavigate = () => {
  const navigateRRD = useNavigate();

  const navigate = useCallback(
    <Path extends keyof Routes>(
      path: Path | number | string,
      params?: Partial<RouteSearch<Path>>,
      options?: NavigateOptions
    ) => {
      if (typeof path === "number") {
        navigateRRD(path);
      } else if (typeof path === "string" && !params) {
        navigateRRD(path);
      } else {
        navigateRRD(
          {
            pathname: path,
            search: mabParamObjectToString(params),
          },
          options
        );
      }
    },
    [navigateRRD]
  );

  return navigate;
};
function mabParamObjectToString(params: object | undefined): string {
  if (!params) return "";
  return (
    "?" +
    Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&")
  );
}
